import { ElementStyle, FieldStyle } from "../../../../../../../../layouts/styles";

export const ListInformationElement = ({ fields, style, styleMainDiv }) => {

    return (
        <ElementStyle className={"d-flex flex-column my-0"} style={{ backgroundColor: 'white', ...style }}>
            <div className="d-flex flex-row flex-wrap flex-md-nowrap" style={{ width: '100%', ...styleMainDiv}}>
                {fields.map((field, index) => (
                    <FieldStyle key={"formation_"+index} className="p-1" style={field.widthLimit ? { width: field.widthLimit } : {}}>
                        <div style={field.style ? field.style : {}}>
                            {field.title}
                            {typeof field.content === "function" ? field.content() : field.content}
                        </div>
                    </FieldStyle>
                ))}
            </div>
        </ElementStyle>
    );
};